import { DiagramSyncService } from '@diagram/services/DiagramSyncService';
import { diagram } from '@diagram/state/diagram';

import { DiagramImage, DiagramInfoBlock, DiagramTextarea } from 'models';

import { InternalTrackingService } from 'services/InternalTrackingService';

type Element = DiagramInfoBlock | DiagramImage | DiagramTextarea;

const ElementHelpers = (type: 'infoBlock' | 'image' | 'group' | 'textarea') => {
    const plural: 'infoBlocks' | 'images' | 'groups' | 'textareas' = `${type}s`;

    const helpers = {
        getById: (id: string) => {
            const elements = (diagram[plural] || []) as Element[];

            let element = null;

            for (let i = 0; i < elements.length && !element; i++) {
                if (elements[i].id === id) {
                    element = elements[i];
                }
            }

            return { element };
        },

        getByIds: (ids: string[]) => {
            const elements = (diagram[plural] || []) as Element[];

            return elements.filter((element) => {
                return ids.includes(element.id);
            });
        },

        move: (id: Element['id'], position: Element['position']) => {
            const { element: current } = helpers.getById(id);

            InternalTrackingService.track(`${plural}.move`, {
                id,
                position,
            });

            if (current) {
                current.position.x = position.x;
                current.position.y = position.y;
            }
        },

        resize: (id: Element['id'], position: Element['position'], size: Element['dimensions'], save = true) => {
            const { element: current } = helpers.getById(id);

            InternalTrackingService.track(`${plural}.resize`, {
                id,
                position,
                size,
            });

            if (current) {
                current.position.x = position.x;
                current.position.y = position.y;
                current.dimensions.width = size.width;
                current.dimensions.height = size.height;
            }

            if (save) {
                DiagramSyncService.save();
            }
        },

        delete: (idOrArray: Element['id'] | Element['id'][]): void => {
            if (typeof idOrArray === 'string') {
                return helpers.delete([idOrArray]);
            }

            if (idOrArray.length === 0) {
                return;
            }

            const keysToDelete = idOrArray.map((id) => `${plural}.${id}`);

            InternalTrackingService.track(`${plural}.delete`, {
                ids: keysToDelete,
            });

            DiagramSyncService.delete(keysToDelete, true);
            DiagramSyncService.save();
        },
    };

    return helpers;
};

export { ElementHelpers };
